import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import mixins from './mixins'
import ElementUI from 'element-ui'
import 'css/base/element_theme.scss'
Vue.use(ElementUI)
Vue.mixin(mixins)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
